module.exports = __webpack_public_path__ + "ec53925ee5ce677eb9e8d079ac0f5aea.jpg";